import * as React from "react";
import { merge, $ } from "glamor";
import { formatMessage } from "lib/globalize-util";
import { SMU_FILTER } from "constants/product-collection";

interface IProps {
    filterAssortmentBySMU: () => SMU_FILTER;
    onFilterAssortmentBySMU: (value: SMU_FILTER) => void;
}

const SMU_OPTIONS = [
    {
        key: SMU_FILTER.All,
        value: "All",
    },
    {
        key: SMU_FILTER.SMUOnly,
        value: "SMU Only",
    },
    {
        key: SMU_FILTER.ExcludeSMU,
        value: "Exclude SMU",
    },
];

export const SMUToolPanel: React.FunctionComponent<IProps> = ({ onFilterAssortmentBySMU, filterAssortmentBySMU }) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                width: "100%",
            },
            $(" .smuLabel", {
                padding: "10px",
                color: "rgba(0, 0, 0, 0.54)",
                fontWeight: "600",
            }),
            $(" .smuOptions", {
                padding: "0 10px",
                display: "grid",
            }),
            $(" .smuOption", {
                height: "20px",
                display: "flex",
            }),
            $(" .smuOption div", {
                lineHeight: "20px",
                paddingLeft: "10px",
            })
        );
    }, []);

    const handleFilterAssortmentBySMU = React.useCallback(
        (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
            const smuValue = event.currentTarget.getAttribute("data-key") as SMU_FILTER;
            onFilterAssortmentBySMU(smuValue);
        },
        [onFilterAssortmentBySMU]
    );

    return (
        <div {...styles}>
            <div className="smuLabel">{formatMessage("SMU Filter")}</div>
            <div className="smuOptions">
                {SMU_OPTIONS.map(({ key, value }) => {
                    return (
                        <div className="smuOption" key={key}>
                            <input
                                type="radio"
                                name="smuFilter"
                                value={key}
                                data-key={key}
                                defaultChecked={key === filterAssortmentBySMU()}
                                onClick={handleFilterAssortmentBySMU}
                                data-test={`filter-${key}`}
                            />
                            <div>{formatMessage(value)}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
